import QuestionCard from "elements/QuestionCard";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";

const FarmLand = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<QuestionCard
				id="farmland"
				value={
					specialFieldsValue?.is_property_used_for_commercial_agricultural_purposes
				}
				setValue={(v: boolean | undefined) =>
					setSpecialFieldsValue({
						is_property_used_for_commercial_agricultural_purposes: v,
					})
				}
				tooltipText=""
				question="Is the property 10 or more acres AND have buildings/structures that are being used for commercial agricultural production?"></QuestionCard>
			{specialFieldsValue?.is_property_used_for_commercial_agricultural_purposes ===
				true && (
				<p className="sm exemptions-notification-message-rust">
					Your property may qualify for the Farmstead Exemption, which we
					currently cannot support due to additional requirements and evidence
					from the county. We recommend that you still file directly through the
					county to get the maximum benefit you deserve.
				</p>
			)}
			<ButtonV2
				size="large"
				disabled={
					specialFieldsValue?.is_property_used_for_commercial_agricultural_purposes ===
					undefined
				}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default FarmLand;
